const actions = {
  CREATE_MOBILE_APP_CONFIGURATION: 'CREATE_MOBILE_APP_CONFIGURATION',
  CREATE_MOBILE_APP_CONFIGURATION_ENDED: 'CREATE_MOBILE_APP_CONFIGURATION_ENDED',
  SEARCH_MOBILE_APP_CONFIGURATIONS: 'SEARCH_MOBILE_APP_CONFIGURATIONS',
  SEARCH_MOBILE_APP_CONFIGURATIONS_ENDED: 'SEARCH_MOBILE_APP_CONFIGURATIONS_ENDED',
  UPDATE_MOBILE_APP_CONFIGURATION: 'UPDATE_MOBILE_APP_CONFIGURATION',
  UPDATE_MOBILE_APP_CONFIGURATION_ENDED: 'UPDATE_MOBILE_APP_CONFIGURATION_ENDED',
  CREATE_MOBILE_APP_COPYWRITING: 'CREATE_MOBILE_APP_COPYWRITING',
  CREATE_MOBILE_APP_COPYWRITING_ENDED: 'CREATE_MOBILE_APP_COPYWRITING_ENDED',
  SEARCH_MOBILE_APP_COPYWRITINGS: 'SEARCH_MOBILE_APP_COPYWRITINGS',
  SEARCH_MOBILE_APP_COPYWRITINGS_ENDED: 'SEARCH_MOBILE_APP_COPYWRITINGS_ENDED',
  UPDATE_MOBILE_APP_COPYWRITING: 'UPDATE_MOBILE_APP_COPYWRITING',
  UPDATE_MOBILE_APP_COPYWRITING_ENDED: 'UPDATE_MOBILE_APP_COPYWRITING_ENDED',
};

export default actions;
